import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useSelector } from "react-redux";
import "./newUser.css";
import firebase, { storage } from "../../config/firebase";
import { ref, getDownloadURL, uploadBytesResumable, } from "firebase/storage";
import { useNavigate, useParams, Link, useLocation, Navigate } from "react-router-dom";
import authApi from "../../service/modules/auth.api";
import Radio from "@mui/material/Radio";
import { AutoComplete, Input } from 'antd';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputMask from "react-input-mask";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { Button, Card, Autocomplete, TextField, Box, Divider, CardContent, Stack, Typography, CircularProgress } from "@mui/material";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import Permissions, {
    calcularSelecionarTodosGeralCoerente,
    PERMISSION_MASTER_GROUP_KEYS,
} from "../../components/permission";
import CreateListPerfil from "../perfil/CreateListPerfil";
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import perfilService from "../../service/perfil.service";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from '@mui/icons-material/Delete';
import TransferList from "../../components/TransferList/transferList";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {
    clampPermissoesToAllowed,
    canUsePermissionDevMode,
    toggleScopedPermission,
    toggleSelecionarTodosGeralPorEscopo,
} from "../../util/permissions/permissionScope";
import {
    canCreateCustomPerfil,
    getSystemDefaultPermissoes,
    getVisibleSystemDefaultProfileOptions,
    isSystemDefaultProfile,
} from "../../util/permissions/defaultProfiles";
import { GlobalSuccessModal, GlobalWarningGlobal } from "../../components/modalGlobal/modalGlobal";
import { validatorEmail, validatorCPF, validatorCNPJ } from "../../components/validators/validators";
import { cardIconSx, newClientThemeVars } from "../../theme/globalStyle/globalStyle";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
// Função para comparar objetos de permissões de forma profunda
function comparePermissoes(obj1, obj2) {
    // Se os tipos são diferentes, não são iguais
    if (typeof obj1 !== typeof obj2) return false;

    // Se não são objetos ou são null, compara diretamente
    if (typeof obj1 !== 'object' || obj1 === null || obj2 === null) {
        return obj1 === obj2;
    }

    // Compara as chaves
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;

    // Para cada chave, compara os valores recursivamente
    return keys1.every(key => {
        if (!obj2.hasOwnProperty(key)) return false;
        return comparePermissoes(obj1[key], obj2[key]);
    });
}

require("firebase/auth");

const EMPTY_PERMISSOES = {
    // Permissões de Estatisticas
    salesDashboard: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    // Permissões de Cadastro
    freight: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    freightPricing: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    freightDriver: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    freightFreight: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    freightViewEditDriver: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    freightCannotRelease: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    freightCancel: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    freightStoppingPointLatLong: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    client: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    driver: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    shipper: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    vehicle: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    user: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    product: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    simulatorFreight: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    lances: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    filasTransportadoras: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    budget: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    // Permissões de Parametrização
    mdfe: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    revenue: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    import: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    payment: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    freightControl: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    freightControlDocuments: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    freightControlBoleto: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    tableIcms: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    ocurrence: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    tablePrice: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    accompaniment: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    perfil: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    generalReport: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
    paymentCondition: { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false },
};

/** Preset do formulário: começa com tudo liberado; o clamp por escopo limita o que o criador pode conceder. */
const INITIAL_PERMISSOES = Object.keys(EMPTY_PERMISSOES).reduce((accCanCreatePerfil, groupKey) => {
    accCanCreatePerfil[groupKey] = {
        selecionarTodos: true,
        isView: true,
        isCreate: true,
        isEdit: true,
        isDelete: true,
    };
    return accCanCreatePerfil;
}, {});

function mergePermissoesFrom(source = {}, fallback = EMPTY_PERMISSOES) {
    const result = {};
    for (const key of Object.keys(fallback)) {
        const maybe = source?.[key] ?? {};
        result[key] = {
            selecionarTodos: maybe?.selecionarTodos ?? false,
            isView: maybe?.isView ?? false,
            isCreate: maybe?.isCreate ?? false,
            isEdit: maybe?.isEdit ?? false,
            isDelete: maybe?.isDelete ?? false,
        };
    }
    return result;
}

function NewUser() {
    const { id } = useParams();
    const navigate = useNavigate();
    const user = useSelector((s) => s.user);
    const location = useLocation();

    const [view, setOnlyView] = useState(location.state?.viewOnly || false);

    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [senha2, setSenha2] = useState("");
    const [authUid, setAuthUid] = useState("");
    const [perfil, setPerfil] = useState("personalizado");
    const [name, setName] = useState("");
    const [cpf, setCpf] = useState("");
    const [shippers, setShippers] = useState([]);
    const [selectedShippers, setSelectedShippers] = useState([]);
    const [shipper, setShipper] = useState(user?.uidShipper || "0");
    const [viewALL, setViewALL] = useState(false);
    const [originalViewALL, setOriginalViewALL] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [ativo, setAtivo] = useState("");
    const [isSeller, setIsSeller] = useState(false);
    const [image, setImage] = useState("");
    const [file, setFile] = useState(null);

    const [msgTipo, setMsgTipo] = useState();
    const [carregando, setCarregando] = useState(false);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState();
    const [title, setTitle] = useState();
    const [perfilList, setPerfilList] = useState([]);
    const [perfilSelect, setPerfilSelecionado] = useState(null);

    const [permissoes, setPermissoes] = useState(INITIAL_PERMISSOES);
    const [selecionarTodosGeral, setSelecionarTodosGeral] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [isLoadingUser, setIsLoadingUser] = useState(false);
    /** Switch temporário UI — não altera user.devMode permanente. */
    const [isDevModeEnabled, setIsDevModeEnabled] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successModalTitle, setSuccessModalTitle] = useState("Usuário cadastrado com sucesso!");
    const [shouldNavigateToUserList, setShouldNavigateToUserList] = useState(false);
    const [showWarningGlobal, setShowWarningGlobal] = useState(false);
    const [warningModalTitle, setWarningModalTitle] = useState("");
    const [cpfError, setCpfError] = useState("");
    const [emailError, setEmailError] = useState("");

    const [listUser, setListUser] = useState([]);

    const [comparEPermissoes, setComparePermissoes] = useState([]);
    const [originalUserPermissoes, setOriginalUserPermissoes] =
        useState(EMPTY_PERMISSOES);

    const canUseDevModeSwitch = canUsePermissionDevMode(user);

    useEffect(() => {
        if (!canUseDevModeSwitch && isDevModeEnabled) {
            setIsDevModeEnabled(false);
        }
    }, [canUseDevModeSwitch, isDevModeEnabled]);

    const allowedPermissoes = useMemo(
        () => {
            const merged = mergePermissoesFrom(user?.permissoes);
            return PERMISSION_MASTER_GROUP_KEYS.reduce((acc, groupKey) => {
                acc[groupKey] = merged[groupKey] || EMPTY_PERMISSOES[groupKey];
                return acc;
            }, {});
        },
        [user?.permissoes],
    );

    const isSystemProfile = isSystemDefaultProfile(perfil);

    /** Escopo efetivo: null = matriz completa (devMode switch ligado + elegível). */
    const effectiveAllowedPermissoes = useMemo(() => {
        if (canUseDevModeSwitch && isDevModeEnabled) {
            return null;
        }
        if (isSystemProfile) {
            return permissoes;
        }
        return allowedPermissoes;
    }, [
        canUseDevModeSwitch,
        isDevModeEnabled,
        isSystemProfile,
        permissoes,
        allowedPermissoes,
    ]);

    const handleDevModeEnabledChange = useCallback(
        (enabled) => {
            if (!canUseDevModeSwitch) {
                setIsDevModeEnabled(false);
                return;
            }
            // Ligar/desligar só muda a visão. Não altera permissoes nem "Selecionar Todos".
            // O clamp de segurança roda apenas no save/update quando o switch estiver off.
            setIsDevModeEnabled(Boolean(enabled));
        },
        [canUseDevModeSwitch],
    );

    /** Snapshot a gravar: em devMode (switch on) persiste a matriz completa sem clamp. */
    const buildPermissoesForPersist = useCallback(() => {
        if (isSystemDefaultProfile(perfil)) {
            return getSystemDefaultPermissoes(perfil);
        }
        if (canUseDevModeSwitch && isDevModeEnabled) {
            return mergePermissoesFrom(permissoes);
        }
        return clampPermissoesToAllowed(
            permissoes,
            allowedPermissoes,
            id ? originalUserPermissoes : EMPTY_PERMISSOES,
        );
    }, [
        perfil,
        canUseDevModeSwitch,
        isDevModeEnabled,
        permissoes,
        allowedPermissoes,
        id,
        originalUserPermissoes,
    ]);

    // helpers
    const handleChangeCheckbox = (event) => {
        if (!user?.viewALL) return;
        setViewALL(event.target.checked);
    }

    const handleChange = useCallback((grupo, campo) => {
        setPermissoes((prev) => {
            const novo = toggleScopedPermission(
                prev,
                effectiveAllowedPermissoes,
                grupo,
                campo,
            );

            setSelecionarTodosGeral(
                calcularSelecionarTodosGeralCoerente(novo, effectiveAllowedPermissoes),
            );
            return novo;
        });
    }, [effectiveAllowedPermissoes]);

    const handleSelecionarTodosGeral = useCallback(() => {
        setPermissoes((prev) => {
            const novo = toggleSelecionarTodosGeralPorEscopo(
                prev,
                effectiveAllowedPermissoes,
            );
            setSelecionarTodosGeral(
                calcularSelecionarTodosGeralCoerente(novo, effectiveAllowedPermissoes),
            );
            return novo;
        });
    }, [effectiveAllowedPermissoes]);

    // image upload returns URL
    const uploadImage = useCallback(
        async (fileToUpload) => {
            if (!fileToUpload) return null;
            try {
                const storageRef = ref(storage, `files/user/${cpf || "unknown"}`);
                await uploadBytesResumable(storageRef, fileToUpload);
                const url = await getDownloadURL(storageRef);
                setImage(url);
                return url;
            } catch (err) {
                console.error("Erro upload imagem:", err);
                return null;
            }
        },
        [cpf]
    );

    async function loadImage(filePath) {
        try {
            const fileRef = ref(storage, filePath);
            const url = await getDownloadURL(fileRef);
            setImage(url);
        } catch (err) {
            console.error("Erro ao buscar imagem:", err);
        }
    }

    const fetchPerfil = async () => {
        const list = await perfilService.getPerfis();
        if (!list) return console.error("Erro na busca de dados de perfil!");
        const loggedShipperId = String(user?.uidShipper || "").trim();
        const scopedPerfilList = list.filter((perfilItem) => {
            if (!loggedShipperId) return false;
            return String(perfilItem?.uidShipper || "").trim() === loggedShipperId;
        });
        setPerfilList(scopedPerfilList);

        const snapshot = await firebase.firestore().collection("user_web").get();
        if (!listUser) return console.error("Erro na busca de dados de usuário!");
        const users = snapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .filter((userItem) => {
                if (!loggedShipperId) return false;
                return String(userItem?.uidShipper || "").trim() === loggedShipperId;
            });
        setListUser(users);
    };

    function isAllPermissoesFalse(permissoesObj) {
        return Object.values(permissoesObj).every(g =>
            !g?.selecionarTodos && !g?.isView && !g?.isCreate && !g?.isEdit && !g?.isDelete
        );
    }

    // fetch shippers & perfis once
    useEffect(() => {
        let mounted = true;
        const load = async () => {
            setCarregando(true);
            try {
                await fetchPerfil();

                // Lógica para carregar shippers
                if (user?.viewALL) {
                    const snapshot = await firebase.firestore().collection("shipper").get();
                    if (!mounted) return;
                    setShippers(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
                } else {
                    // Coleta todos os UIDs possíveis sem aninhamento
                    const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
                    const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
                    const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

                    if (uids.length > 0) {
                        const shipperPromises = uids.map((uid) =>
                            firebase.firestore().collection("shipper").doc(uid).get()
                        );
                        const shipperDocs = await Promise.all(shipperPromises);
                        if (!mounted) return;
                        const shipperData = shipperDocs
                            .filter((doc) => doc.exists)
                            .map((doc) => ({ id: doc.id, ...doc.data() }));
                        setShippers(shipperData);
                    } else {
                        setShippers([]);
                    }
                }

                // Carregar dados do usuário se houver ID
                if (id) {
                    setIsLoadingUser(true);

                    const doc = await firebase.firestore().collection("user_web").doc(id).get();
                    const userData = doc.data() || {};

                    if (!mounted) return;

                    setName(userData.name ?? "");
                    setCpf(userData.cpf ?? "");
                    setEmail(userData.email ?? "");
                    setAuthUid(String(userData.uid || "").trim());
                    setPhoneNumber(userData.phoneNumber ?? "");
                    setPerfil(userData?.perfil);
                    setShipper(userData?.uidShipper || "0");
                    // Corrigido: não envolve array em outro array
                    setSelectedShippers(Array.isArray(userData?.uidShipperAffiliates) ? userData.uidShipperAffiliates : []);
                    setAtivo(userData.ativo ?? "");
                    setIsSeller(Boolean(userData.isSeller));
                    setViewALL(Boolean(userData.viewALL));
                    setOriginalViewALL(Boolean(userData.viewALL));
                    const mergedPerm = mergePermissoesFrom(userData.permissoes);
                    setPermissoes(mergedPerm);
                    setComparePermissoes(mergedPerm);
                    setOriginalUserPermissoes(mergedPerm);
                    setSelecionarTodosGeral(
                        calcularSelecionarTodosGeralCoerente(
                            mergedPerm,
                            allowedPermissoes,
                        ),
                    );

                    if (userData.file) {
                        await loadImage(userData.file);
                    }

                    setIsLoadingUser(false);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setCarregando(false);
            }
        };

        load();
        return () => {
            mounted = false;
        };
    }, [id, user, allowedPermissoes]);

    const currentShipper = useMemo(() => {
        const shipperId = String(user?.uidShipper || "").trim();
        if (!shipperId) return null;
        return shippers.find((item) => String(item?.id || "").trim() === shipperId) || null;
    }, [shippers, user?.uidShipper]);

    const visibleSystemProfileOptions = useMemo(() => {
        const options = getVisibleSystemDefaultProfileOptions(user, currentShipper);
        // Mantém o valor atual visível na edição, mesmo se o criador não puder atribuí-lo.
        if (
            id &&
            isSystemDefaultProfile(perfil) &&
            !options.some((option) => option.value === perfil)
        ) {
            return [...options, { value: perfil, label: perfil }];
        }
        return options;
    }, [user, currentShipper, id, perfil]);

    const canCreatePerfil = useMemo(
        () => canCreateCustomPerfil(user),
        [user],
    );

    // 🔹 Quando o perfil muda, atualiza permissões e guarda referência
    useEffect(() => {
        if (!perfil || perfil === "personalizado") return;

        if (isSystemDefaultProfile(perfil)) {
            const novasPermissoes = getSystemDefaultPermissoes(perfil);
            if (!novasPermissoes) return;

            setPermissoes(novasPermissoes);
            setSelecionarTodosGeral(
                calcularSelecionarTodosGeralCoerente(
                    novasPermissoes,
                    novasPermissoes,
                ),
            );
            setPerfilSelecionado(null);
            setComparePermissoes(novasPermissoes);
            return;
        }

        const perfilSelecionado = perfilList.find((p) => p.nomePerfil === perfil);
        if (!perfilSelecionado) return;

        const novasPermissoes = clampPermissoesToAllowed(
            mergePermissoesFrom(perfilSelecionado.permissoes),
            allowedPermissoes,
            originalUserPermissoes,
        );
        setPermissoes(novasPermissoes);
        setSelecionarTodosGeral(
            calcularSelecionarTodosGeralCoerente(
                novasPermissoes,
                allowedPermissoes,
            ),
        );
        setPerfilSelecionado(perfilSelecionado);
        setComparePermissoes(novasPermissoes);

    }, [perfil, perfilList, allowedPermissoes, originalUserPermissoes]);

    // 🔹 Detecta quando as permissões mudarem e forem diferentes das do perfil atual
    useEffect(() => {
        if (isLoadingUser) return;
        if (!perfil || perfil === "personalizado") return;
        if (isSystemDefaultProfile(perfil)) return;
        if (!user?.permissoes?.user?.isView) return;

        const permissoesSaoDiferentes = !comparePermissoes(permissoes, comparEPermissoes);

        if (permissoesSaoDiferentes) {
            if (isAllPermissoesFalse(permissoes)) {
                return;
            }
            else {
                console.log("Permissões modificadas - mudando para personalizado");
                setPerfil("personalizado");
            }
        }
    }, [permissoes, comparEPermissoes, perfil, isLoadingUser, user?.permissoes?.user?.isView]);

    // handlers
    const handleStatus = (e) => setAtivo(e.target.value);

    const handleImageChange = async (e) => {
        const f = e.target.files?.[0];
        if (f) {
            setFile(f);
            await uploadImage(f);
        }
    };

    const handleClose = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        setOpen(false);
    };

    const validateCpf = (value) => {
        setCpf(value);
        if (!value || value.trim() === "") {
            setCpfError("");
        } else if (!validatorCPF(value)) {
            setCpfError("CPF inválido");
        } else {
            setCpfError("");
        }
    };

    const validateEmail = (value) => {
        setEmail(value);
        if (!value || value.trim() === "") {
            setEmailError("");
        } else if (!validatorEmail(value)) {
            setEmailError("E-mail inválido");
        } else {
            setEmailError("");
        }
    }

    const validateRequired = () => {
        const missing = [];

        if (!email) missing.push("E-mail");
        if (!id && !senha) missing.push("Senha");
        if (!name) missing.push("Nome");
        if (!cpf) missing.push("CPF");
        if (!phoneNumber) missing.push("Telefone");
        if (!ativo) missing.push("Status (Ativo ou Inativo)");

        if (missing.length > 0) {
            setMsgTipo("erro");
            setMsg(`Todos os campos são de preenchimento obrigatório: ${missing.join(", ")}`);
            setTitle("Oops!");
            setOpen(true);
            return false;
        }
        if (cpfError || emailError) {
            setMsgTipo("erro");
            setMsg("Por favor, corrija os campos em vermelho antes de salvar.");
            setTitle("Oops!");
            setOpen(true);
            return false;
        }
        if (shipper === "0") {
            setMsgTipo("erro");
            setMsg("Por favor, escolha um Embarcador válido");
            setTitle("Oops!");
            setOpen(true);
            return false;
        }
        return true;
    };

    const save = async () => {
        setCarregando(true);
        try {
            if (!validateRequired()) return;

            if (senha.length < 6) {
                setMsgTipo("erro");
                setMsg("A senha deve ter pelo menos 6 caracteres");
                setTitle("Oops!");
                setOpen(true);
                return;
            }

            if (senha !== senha2) {
                setMsgTipo("erro");
                setMsg("Senha diferente da confirmação, por favor tente novamente.");
                setTitle("Oops!");
                setOpen(true);
                return;
            }

            if (file) {
                await uploadImage(file);
            }

            const resultado = await firebase.auth().createUserWithEmailAndPassword(email, senha);
            const uid = resultado.user.uid;
            const scopedPermissoes = buildPermissoesForPersist();
            const dataUser = {
                uid,
                email: resultado.user.email,
                perfil,
                name,
                cpf,
                ativo,
                phoneNumber,
                isSeller: isSeller || false,
                accountCreated: new Date(),
                uidShipper: shipper,
                uidShipperAffiliates: selectedShippers,
                viewALL: user?.viewALL ? viewALL || false : false,
                permissoes: scopedPermissoes,
                permissoesAll: calcularSelecionarTodosGeralCoerente(
                    scopedPermissoes,
                    isSystemDefaultProfile(perfil)
                        ? scopedPermissoes
                        : effectiveAllowedPermissoes,
                ),
                file: image,
            };

            await firebase.firestore().collection("user_web").add(dataUser);
            setSuccessModalTitle("Usuário cadastrado com sucesso!");
            setShouldNavigateToUserList(true);
            setShowSuccessModal(true);
        } catch (error) {
            setMsgTipo("erro");
            const err = (error?.message || "").toString();
            if (err.includes("weak-password")) setMsg("A senha deve ter pelo menos 6 caracteres");
            else if (err.includes("email-already-in-use")) setMsg("Este e-mail já está sendo utilizado por outro usuário");
            else if (err.includes("invalid-email")) setMsg("O formato do seu e-mail é inválido!");
            else setMsg("Não foi possível cadastrar. Tente novamente mais tarde ou contate o administrador!");
            setTitle("Oops!");
            setOpen(true);
        } finally {
            setCarregando(false);
        }
    };

    const update = async () => {
        setCarregando(true);
        try {
            if (!validateRequired()) return;

            if (senha && senha.length < 6) {
                setMsgTipo("erro");
                setMsg("A senha deve ter pelo menos 6 caracteres");
                setTitle("Oops!");
                setOpen(true);
                return;
            }

            if (senha && senha !== senha2) {
                setMsgTipo("erro");
                setMsg("Senha diferente da confirmação, por favor tente novamente.");
                setTitle("Oops!");
                setOpen(true);
                return;
            }

            if (senha) {
                try {
                    await authApi.updatePassword({
                        uid: authUid || undefined,
                        email: email || undefined,
                        password: senha,
                    });
                } catch (err) {
                    console.error("[NewUser] Erro ao alterar senha:", err);
                    const apiMsg =
                        err?.response?.data?.message ||
                        err?.response?.data?.error ||
                        "";
                    setMsgTipo("erro");
                    setMsg(
                        Array.isArray(apiMsg)
                            ? apiMsg.join(", ")
                            : apiMsg ||
                            "Não foi possível alterar a senha. Tente novamente.",
                    );
                    setTitle("Oops!");
                    setOpen(true);
                    return;
                }
            }

            if (file) {
                await uploadImage(file);
            }

            const scopedPermissoes = buildPermissoesForPersist();
            const dataUser = {
                email,
                perfil,
                name,
                cpf,
                ativo,
                phoneNumber,
                isSeller: isSeller || false,
                accountUpdate: new Date(),
                uidShipper: shipper,
                uidShipperAffiliates: selectedShippers,
                viewALL: user?.viewALL ? viewALL || false : originalViewALL,
                permissoes: scopedPermissoes,
                permissoesAll: calcularSelecionarTodosGeralCoerente(
                    scopedPermissoes,
                    isSystemDefaultProfile(perfil)
                        ? scopedPermissoes
                        : effectiveAllowedPermissoes,
                ),
                file: image,
            };

            await firebase.firestore().collection("user_web").doc(id).update(dataUser);
            setSuccessModalTitle("Usuário atualizado com sucesso!");
            setShouldNavigateToUserList(true);
            setShowSuccessModal(true);
        } catch (error) {
            console.error(error);
            setMsgTipo("erro");
            setMsg("Não foi possível atualizar. Tente novamente.");
            setTitle("Oops!");
            setOpen(true);
        } finally {
            setCarregando(false);
        }
    };

    const perfilOptions = useMemo(() => {
        return perfilList?.map((p) => (
            <option key={p.id} value={p.nomePerfil}>
                {p.nomePerfil}
            </option>
        ));
    }, [perfilList]);

    const userOptions = useMemo(() => {
        // opções formatadas para Autocomplete
        return listUser?.map((u) => ({
            key: u.id,
            label: `${u.name} (${u.perfil})`,
            perfil: u.perfil,
            raw: u,
        })) || [];
    }, [listUser]);

    const getShipperOptionLabel = useCallback((item) => {
        if (!item) return "";
        return (
            item?.dataPersonal?.nameFantasy ||
            item?.dataPersonal?.socialName ||
            item?.socialName ||
            item?.name ||
            ""
        );
    }, []);

    const selectedShipperOption = useMemo(() => {
        if (!shipper || shipper === "0") return null;
        return shippers.find((item) => String(item?.id) === String(shipper)) || null;
    }, [shippers, shipper]);

    const filterShipperOptions = useCallback(
        (options, { inputValue }) => {
            const query = String(inputValue || "")
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .trim();
            if (!query) return options;
            return options.filter((option) => {
                const label = getShipperOptionLabel(option)
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .toLowerCase();
                return label.includes(query);
            });
        },
        [getShipperOptionLabel],
    );

    const pageTitle = view ? "Visualização de usuário" : id ? "Editar usuário" : "Cadastro de usuário";
    const pageSubtitle = view
        ? "Consulte os dados cadastrais e as permissões do usuário."
        : "Preencha os dados para cadastrar ou atualizar usuários com clareza.";

    return (
        <>
            {useSelector((state) => state.usuarioLogado) > 0 ? (
                <NewMiniDrawer
                    divOpen={
                        <Box className="new-user-page" sx={pageWrapperSx} style={newClientThemeVars}>
                        <Card sx={heroCardSx}>
                            <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                                <Box className="new-user-hero">
                                    <Stack spacing={1}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Box sx={cardIconSx}>
                                                <PersonOutlineOutlinedIcon sx={{ color: "#ffffff" }} />
                                            </Box>
                                            <Typography sx={heroTitleSx}>{pageTitle}</Typography>
                                        </Box>
                                        <Typography sx={heroSubtitleSx}>{pageSubtitle}</Typography>
                                    </Stack>

                                    {view ? (
                                        <Box sx={statusPillSx}>Somente leitura</Box>
                                    ) : (
                                        <Box sx={statusPillSx}>{id ? "Atualização" : "Novo registro"}</Box>
                                    )}
                                </Box>
                            </CardContent>
                        </Card>

                        <div className="body">
                            <SectionCard
                                icon={<PersonOutlineOutlinedIcon />}
                                title="Dados principais"
                                subtitle="Foto, identificação, status e perfil de acesso do usuário"
                            >
                            <div className="bodyHead" style={{ background: "transparent", border: "none", boxShadow: "none", padding: 0, marginTop: 0 }}>
                                <div className="bodyHeadLeft">
                                    <div>
                                        <label htmlFor="upload-avatar">
                                            <div
                                                className="logoPerfil"
                                                style={{
                                                    width: "240px",
                                                    height: "240px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "#ccc",
                                                    overflow: "hidden",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                {image ? (
                                                    <img src={image} alt="avatar" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px" }} />
                                                ) : (
                                                    <span style={{ fontSize: "24px", color: "#fff" }}>+</span>
                                                )}
                                            </div>
                                            <div>
                                                {image ? (
                                                    <DeleteIcon disabled={view} className="deleteIconUser" onClick={(e) => { e.stopPropagation(); setImage(""); setFile(""); }} />
                                                ) : null}
                                            </div>
                                        </label>
                                        <input disabled={view} id="upload-avatar" type="file" accept="image/*" onChange={handleImageChange} style={{ display: "none" }} />
                                    </div>

                                    <div>
                                        <h3>{name || "Novo Nome"}</h3>
                                    </div>
                                </div>

                                <div className="bodyHeadRight">
                                    <form>
                                        <div>
                                            <div className="row">
                                                <div className="rowAtivoInativo">
                                                    <div className="radioAtivo">
                                                        <Radio disabled={view} checked={ativo === "Ativo"} onChange={handleStatus} value="Ativo" name="radio-buttons" />
                                                        <label htmlFor="btnradio1">Ativo</label>
                                                        <Radio disabled={view} checked={ativo === "Inativo"} onChange={handleStatus} value="Inativo" name="radio-buttons" />
                                                        <label htmlFor="btnradio2">Inativo</label>
                                                    </div>
                                                </div>
                                            </div>

                                          <Box className="new-user-grid">
    <Field label="Nome" span={4}>
        <input
            disabled={view}
            onChange={(e) => setName(e.target.value)}
            type="text"
            value={name || ""}
            className="form-control"
            placeholder="Nome"
        />
    </Field>

    <Field label="CPF" span={4}>
        <InputMask
            disabled={view}
            mask="999.999.999-99"
            placeholder="000.000.000-00"
            value={cpf || ""}
            className="form-control"
            onChange={(e) => validateCpf(e.target.value)}
        />
        {cpfError && (
            <small style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                {cpfError}
            </small>
        )}
    </Field>

    <Field label="Telefone" span={4}>
        <InputMask
            disabled={view}
            mask="(99) 99999-9999"
            placeholder="(00) 00000-0000"
            value={phoneNumber || ""}
            className="form-control"
            onChange={(e) => setPhoneNumber(e.target.value)}
        />
    </Field>

    <Field label="E-mail" span={4}>
        <input
            onChange={(e) => validateEmail(e.target.value)}
            disabled={!!id || view}
            value={email || ""}
            type="email"
            className="form-control"
            placeholder="exemplo@dominio.com"
        />
        {emailError && (
            <small style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                {emailError}
            </small>
        )}
    </Field>

    <Field label="Senha" span={4}>
        <input
            disabled={view}
            onChange={(e) => setSenha(e.target.value)}
            type="password"
            className="form-control"
            placeholder={id ? "Nova senha (opcional)" : "Senha"}
            autoComplete="new-password"
        />
    </Field>

    <Field label="Repetir senha" span={4}>
        <input
            disabled={view}
            onChange={(e) => setSenha2(e.target.value)}
            type="password"
            className="form-control"
            placeholder={id ? "Repetir nova senha" : "Repetir a senha"}
            autoComplete="new-password"
        />
    </Field>
</Box>


                                            <div className="row">
                                                <Autocomplete
                                                    disabled={view}
                                                    id="companyShipper"
                                                    options={shippers}
                                                    value={selectedShipperOption}
                                                    getOptionLabel={getShipperOptionLabel}
                                                    filterOptions={filterShipperOptions}
                                                    isOptionEqualToValue={(option, value) =>
                                                        String(option?.id || "") === String(value?.id || "")
                                                    }
                                                    onChange={(_, value) => {
                                                        setShipper(value?.id || "0");
                                                    }}
                                                    noOptionsText="Nenhum embarcador encontrado"
                                                    sx={{
                                                        width: "100%",
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: "10px",
                                                            minHeight: "40px",
                                                            background: "#fff",
                                                        },
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Embarcadora"
                                                            size="small"
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className="row">
                                                <FormGroup>
                                                    {user?.viewALL ? (
                                                        <FormControlLabel control={<Checkbox disabled={view} checked={viewALL} onChange={handleChangeCheckbox} color="primary" />} label="Visualiza Todos os Embarcadores" />
                                                    ) : null}
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                disabled={view}
                                                                checked={isSeller}
                                                                onChange={(e) => setIsSeller(e.target.checked)}
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Vendedor"
                                                    />
                                                </FormGroup>
                                            </div>
                                            <div className="row">
                                                {
                                                    viewALL ? null : (
                                                        <TransferList
                                                            disabled={view}
                                                            shippers={shippers}
                                                            selectedShippers={selectedShippers}
                                                            shipper={shipper}
                                                            onChange={(selected) => setSelectedShippers(selected)}
                                                        />
                                                    )
                                                }
                                            </div>

                                            <div className="rowPerfil">
                                                <div id="autoComplete" className="col-8">
                                                    <AutoComplete
                                                        disabled={view}
                                                        style={{ width: '100%', height: '38px', color: '#000' }}
                                                        options={userOptions.map((user) => ({
                                                            value: user.label,
                                                            perfil: user.perfil,
                                                        }))}
                                                        filterOption={(inputValue, option) =>
                                                            option?.value.toLowerCase().includes(inputValue.toLowerCase())
                                                        }
                                                        onSelect={(value, option) => {
                                                            setPerfil(option?.perfil || 'personalizado');
                                                        }}
                                                        onClear={() => setPerfil('personalizado')}
                                                        allowClear
                                                    >
                                                        <Input
                                                            disabled={view}
                                                            className="autoComplete"
                                                            placeholder="Selecione o Usuário"
                                                            style={{
                                                                height: '38px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #c9c9c9ff',
                                                                fontSize: '14px',
                                                            }}
                                                        />
                                                    </AutoComplete>
                                                </div>
                                                <div id="col-8" className="col-8">
                                                    <select
                                                        disabled={view}
                                                        className="form-select"
                                                        id="formPerfil"
                                                        value={perfil || "personalizado"}
                                                        onChange={(e) => {
                                                            if (e.target.value === "criar") {
                                                                if (!canCreatePerfil) {
                                                                    setPerfil(perfil || "personalizado");
                                                                    return;
                                                                }
                                                                navigate("/createPerfil", { state: { permissoes } });
                                                                setPerfil("personalizado");
                                                            } else {
                                                                setPerfil(e.target.value);
                                                            }
                                                        }}
                                                        aria-label=""
                                                    >
                                                        <option value="personalizado"> Personalizado </option>
                                                        {visibleSystemProfileOptions.map((option) => (
                                                            <option key={option.value} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                        {perfilOptions}
                                                        <option value="criar" disabled={!canCreatePerfil}>
                                                            Criar Perfil
                                                        </option>
                                                    </select>

                                                    <Button
                                                        disabled={view || !canCreatePerfil}
                                                        type="button"
                                                        title={
                                                            !canCreatePerfil
                                                                ? "Sem permissão do menu Perfil para criar um novo perfil"
                                                                : "Criar novo perfil"
                                                        }
                                                        onClick={() => {
                                                            if (!canCreatePerfil) return;
                                                            setShowCreateModal(true);
                                                        }}
                                                    >
                                                        <AddIcon />
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            </SectionCard>

                            <Card className="bodyCard">
                                <div className="bodyWork">
                                    <div className="rowTitle">
                                        <h5> Permissões de Acesso </h5>
                                    </div>

                                    <Permissions
                                        view={view || isSystemProfile}
                                        permissoes={permissoes}
                                        allowedPermissions={
                                            isSystemProfile
                                                ? permissoes
                                                : allowedPermissoes
                                        }
                                        isDevModeEnabled={isDevModeEnabled}
                                        onDevModeEnabledChange={
                                            handleDevModeEnabledChange
                                        }
                                        handleChange={handleChange}
                                        handleSelecionarTodosGeral={
                                            handleSelecionarTodosGeral
                                        }
                                    />
                                </div>

                            </Card>

                            {carregando ? (
                    <div className="spinner-border text-danger" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                ) : (
                    <div className="actionsBar">
                        <Button
                            component={Link}
                            to="/userList"
                            variant="outlined"
                            startIcon={<ArrowBackOutlinedIcon />}
                            sx={secondaryActionSx}
                        >
                            Voltar
                        </Button>
                        <Button
                            disabled={view || carregando}
                            variant="contained"
                            startIcon={carregando ? <CircularProgress color="inherit" size={16} /> : <SaveOutlinedIcon />}
                            onClick={id ? update : save}
                            sx={primaryActionSx}
                        >
                            {carregando ? "Salvando..." : "Salvar"}
                        </Button>
                    </div>
                )}
                        </div >

                        <CreateListPerfil
                            open={showCreateModal}
                            onClose={() => setShowCreateModal(false)}
                            allowedPermissions={isSystemProfile ? permissoes : allowedPermissoes}
                            onSaveChange={async (payload) => {
                                setCarregando(true);
                                try {
                                    const novoPerfilNome = typeof payload === 'string' ? payload : payload?.name;
                                    if (novoPerfilNome) {
                                        await fetchPerfil();
                                        setPerfil(novoPerfilNome);
                                        setSuccessModalTitle("Perfil criado com sucesso!");
                                        setShouldNavigateToUserList(false);
                                        setShowSuccessModal(true);
                                    }
                                } catch (error) {
                                    console.error("Erro ao salvar perfil:", error);
                                } finally {
                                    setCarregando(false);
                                }
                            }}
                        />
                        <GlobalSuccessModal
                            open={showSuccessModal}
                            handleClose={() => {
                                setShowSuccessModal(false);
                                if (shouldNavigateToUserList) {
                                    navigate("/userList");
                                }
                            }}
                            title={successModalTitle}
                        />

                        <GlobalWarningGlobal
                            open={open}
                            handleClose={handleClose}
                            title={title || "Oops!"}
                            subtitle={msg}
                        />
                    </Box>
                    }
                />
            ) : (
                <Navigate to="/login" />
            )}
        </>
    );
}



function SectionCard({ icon, title, subtitle, children }) {
    return (
        <Card sx={sectionCardSx}>
            <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
                <Box className="new-user-section-heading">
                    <Box sx={cardIconSx}>{icon}</Box>
                    <Box>
                        <Typography sx={sectionTitleSx}>{title}</Typography>
                        <Typography sx={sectionSubtitleSx}>{subtitle}</Typography>
                    </Box>
                </Box>
                <Divider sx={{ mb: 2, borderColor: "rgba(1, 36, 67, 0.10)" }} />
                {children}
            </CardContent>
        </Card>
    );
}

function Field({ label, span = 3, children }) {
    return (
        <div className={`new-user-field new-user-span-${span}`}>
            <label>{label}</label>
            {children}
        </div>
    );
}


const pageWrapperSx = {
  p: { xs: 2, md: 3 },
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

const heroCardSx = {
  borderRadius: "18px",
  border: "1px solid var(--new-client-primary-border)",
  boxShadow: "var(--new-client-shadow-soft)",
};

const heroTitleSx = {
  color: "var(--new-client-primary)",
  fontWeight: 700,
  fontSize: "1.25rem",
};

const heroSubtitleSx = {
  color: "rgba(1, 36, 67, 0.74)",
  fontSize: "0.92rem",
  lineHeight: 1.5,
  maxWidth: 760,
};

const sectionCardSx = {
  width: "100%",
  borderRadius: "var(--new-client-radius-lg)",
  border: "1px solid var(--new-client-primary-border)",
  boxShadow: "var(--new-client-shadow-section)",
  background: "var(--new-client-surface-soft)",
};

const sectionTitleSx = {
  color: "var(--new-client-primary)",
  fontWeight: 700,
  fontSize: "1.05rem",
};

const sectionSubtitleSx = {
  color: "rgba(1, 36, 67, 0.62)",
  fontSize: "0.79rem",
  lineHeight: 1.45,
};

const statusPillSx = {
  border: "1px solid var(--new-client-primary-border)",
  borderRadius: "999px",
  color: "var(--new-client-primary)",
  background: "var(--new-client-primary-soft)",
  fontSize: "0.78rem",
  fontWeight: 700,
  px: 1.4,
  py: 0.6,
  whiteSpace: "nowrap",
};

const primaryActionSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  backgroundColor: "var(--new-client-primary)",
  minHeight: 40,
  px: 2,
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "var(--new-client-primary-hover)",
  },
 
};

const secondaryActionSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  borderColor: "rgba(1, 36, 67, 0.28)",
  color: "var(--new-client-primary)",
  minHeight: 40,
  px: 2,
};


export default NewUser;
